import React from 'react';
import {
  Form,
  Input,
  Radio,
  Checkbox,
  Select,
  Tooltip,
  AutoComplete,
  InputNumber,
  DatePicker,
} from 'antd';
import { Field } from 'redux-form';
import moment, { Moment } from 'moment';
import { defaultDateFormat, InputTypes } from 'common';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const componentStyle = {
  minWidth: '213.4px',
};

const makeField =
  (Component: any, style?: any) =>
  ({ input, meta, children, label, className, tooltip, ...rest }: any) => {
    const hasWarning = meta.touched && meta.warning;
    const hasError = meta.error;
    const validateStatus = hasError
      ? 'error'
      : hasWarning
      ? 'warning'
      : 'success';

    return (
      <FormItem
        className={className}
        label={label}
        validateStatus={validateStatus}
        help={(hasWarning && meta.warning) || (hasError && meta.error)}
      >
        <Tooltip title={tooltip}>
          <Component
            allowClear={true}
            {...input}
            {...rest}
            style={style}
            autoComplete="off"
          >
            {children}
          </Component>
        </Tooltip>
      </FormItem>
    );
  };
// TODO Workaround!!! Should be fixed!!!
const makeDatePickerField =
  (Component: any, style?: any) =>
  ({
    input,
    meta,
    children,
    label,
    className,
    tooltip,
    datepickervalue,
  }: any) => {
    const hasWarning = meta.touched && meta.warning;
    const hasError = meta.error;
    const validateStatus = hasError
      ? 'error'
      : hasWarning
      ? 'warning'
      : 'success';
    return (
      <FormItem
        className={className}
        label={label}
        validateStatus={validateStatus}
        help={(hasWarning && meta.warning) || (hasError && meta.error)}
      >
        <Tooltip title={tooltip}>
          <Component
            allowClear={true}
            name={input.name}
            onBlur={input.onBlur}
            onDragStart={input.onDragStart}
            onDrop={input.onDrop}
            onFocus={input.onFocus}
            value={datepickervalue._i ? datepickervalue : null}
            style={style}
            format={defaultDateFormat}
            onChange={(date: any, dateString: string) => {
              dateString === ''
                ? input.onChange(dateString)
                : input.onChange(moment(dateString).format(defaultDateFormat));
            }}
          >
            {children}
          </Component>
        </Tooltip>
      </FormItem>
    );
  };

const input = makeField(Input);
const radio = makeField(Radio);
const checkbox = makeField(Checkbox);
const radioGroup = makeField(RadioGroup);
const select = makeField(Select);
const autoComplete = makeField(AutoComplete);
const inputNumber = makeField(InputNumber, componentStyle);
const password = makeField(Input.Password);
const datePicker = makeDatePickerField(DatePicker);

const getComponent = (inputType: string | undefined) => {
  switch (inputType) {
    case InputTypes.RADIO_GROUP:
      return radioGroup;
    case InputTypes.CHECK_BOX:
      return checkbox;
    case InputTypes.RADIO:
      return radio;
    case InputTypes.SELECT:
      return select;
    case InputTypes.AUTOCOMPLETE:
      return autoComplete;
    case InputTypes.INPUT_NUMBER:
      return inputNumber;
    case InputTypes.PASSWORD:
      return password;
    case InputTypes.DATE_PICKER:
      return datePicker;
    default:
      return input;
  }
};

const FormField: React.FC<{
  name: string;
  id?: string;
  className?: string;
  label?: string;
  inputType?: string;
  prefix?: any;
  placeholder?: string;
  children?: any;
  value?: any;
  datepickervalue?: Moment;
  onFocus?: any;
  tabIndex?: any;
  autoFocus?: any;
  tooltip?: string;
  warn?: any;
  validate?: any;
  disabled?: boolean;
  addonAfter?: any;
  suffix?: any;
  dataSource?: any;
  onSelect?: any;
  onChange?: any;
  allowClear?: boolean;
  buttonStyle?: any;
  showSearch?: any;
  filterOption?: any;
  ref?: any;
  style?: any;
}> = ({ inputType, value, datepickervalue, ...rest }) => {
  return (
    <Field
      component={getComponent(inputType)}
      type={inputType}
      value={value}
      datepickervalue={inputType === 'datePicker' ? datepickervalue : undefined}
      {...rest}
    />
  );
};

export default FormField;
